import { Button, Dialog, DialogContent, DialogTitle, Divider, FormHelperText, IconButton, InputAdornment, Stack, TextField, Typography } from "@mui/material";
import { Controller, useForm } from "react-hook-form";
import DraggablePaper from "../common/DraggablePaper";
import { CONTENT_COLOR, MAIN_HEADER_COLOR } from "../../models/Constants";
import { useEffect, useState } from "react";
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';

export type ChangePasswordForm = {
    oldPassword : string;
    newPassword : string;
    rePassword : string;
}

export type ChangePasswordProps = {
    onOK: (data: any) => void;
    onCancel: () => void;
};

export const ChangePasswordDialog = (props: ChangePasswordProps) => {
    //#region fields
    const { onOK, onCancel } = props;

    const [showOldPassword, setShowOldPassword] = useState(false)
    const [showNewPassword, setShowNewPassword] = useState(false)
    const [showRePassword, setShowRePassword] = useState(false)
    // 初期値設定

    const { control, handleSubmit, formState: { errors }, setValue, getValues, setError, clearErrors } = useForm<ChangePasswordForm>({
        mode: "all",
        criteriaMode: "all",
        defaultValues: {oldPassword : "",newPassword : "",rePassword : ""},
    })
    //#endregion fields

    //#region methods
    // Submitイベント
    const handleEditSubmit = (value: any, event: any) => {
        clearErrors()
        if(getValues("newPassword") != getValues("rePassword"))
        {
            setError("rePassword",{ type: 'custom', message:"確認パスワードが一致しません"})
        }
        else
        {
            const request = createRequestData(value);
            onOK(request);
        }
    }
    
    // FormデータからRequestデータを作成する
    const createRequestData = (formValue : ChangePasswordForm) => {       
        let request = {
            ...formValue
        };
        return request;
    }

    //#endregion methods

    return (
        <>
            <Dialog open={true} maxWidth={"xs"} fullWidth
                PaperComponent={
                    DraggablePaper
                }
            >
                <DialogTitle 
                    onMouseOver={(e : any) => e.target.style.cursor = 'move'}
                    style={{ paddingTop: '2px', paddingBottom: '2px', background: MAIN_HEADER_COLOR, color: 'white' }}
                >
                    <Typography variant="h5" color={CONTENT_COLOR}>パスワード変更</Typography>
                </DialogTitle>
                <Divider/>
                <DialogContent style={{paddingTop: '10px', display: 'flex', alignItems: 'flex-end'}}>
                    <div style={{width: '100%', marginTop:"10px"}}>
                        <form onSubmit={handleSubmit(handleEditSubmit)}>
                            <Stack spacing={3}>
                                <Stack>
                                    <Controller
                                        name="oldPassword"
                                        control={control}
                                        rules={{ required: "必須項目です。入力してください。"}}
                                        render={({ field }) => (
                                            <TextField
                                                {...field}
                                                fullWidth
                                                type={showOldPassword ? 'text' : 'password'}
                                                size="small"
                                                label={<Typography variant="body1">現在のパスワード</Typography>}
                                                InputProps={{
                                                    endAdornment:(
                                                        <InputAdornment position="end">
                                                          <IconButton
                                                            aria-label={
                                                                showOldPassword ? 'hide the password' : 'display the password'
                                                            }
                                                            onClick={()=>setShowOldPassword((show) => !show)}
                                                            onMouseDown={(e)=>e.preventDefault()}
                                                            onMouseUp={(e)=>e.preventDefault()}
                                                            edge="end"
                                                          >
                                                            {showOldPassword ? <VisibilityOff /> : <Visibility />}
                                                          </IconButton>
                                                        </InputAdornment>
                                                    )
                                                }}
                                                error={!!errors?.oldPassword}
                                                helperText={errors?.oldPassword?.message}
                                            />
                                        )}
                                    />
                                </Stack>
                                <Stack>
                                    <Controller
                                        name="newPassword"
                                        control={control}
                                        rules={{ required: "必須項目です。入力してください。"}}
                                        render={({ field }) => (
                                            <TextField
                                                {...field}
                                                fullWidth
                                                type={showNewPassword ? 'text' : 'password'}
                                                size="small"
                                                label={<Typography variant="body1">新しいパスワード</Typography>}
                                                InputProps={{
                                                    endAdornment:(
                                                        <InputAdornment position="end">
                                                          <IconButton
                                                            aria-label={
                                                                showNewPassword ? 'hide the password' : 'display the password'
                                                            }
                                                            onClick={()=>setShowNewPassword((show) => !show)}
                                                            onMouseDown={(e)=>e.preventDefault()}
                                                            onMouseUp={(e)=>e.preventDefault()}
                                                            edge="end"
                                                          >
                                                            {showNewPassword ? <VisibilityOff /> : <Visibility />}
                                                          </IconButton>
                                                        </InputAdornment>
                                                    )
                                                }}
                                                error={!!errors?.newPassword}
                                                helperText={errors?.newPassword?.message}
                                            />
                                        )}
                                    />
                                </Stack>
                                <Stack>
                                    <Controller
                                        name="rePassword"
                                        control={control}
                                        rules={{ required: "必須項目です。入力してください。"}}
                                        render={({ field }) => (
                                            <TextField
                                                {...field}
                                                fullWidth
                                                type={showRePassword ? 'text' : 'password'}
                                                size="small"
                                                label={<Typography variant="body1">新しいパスワード（確認用）</Typography>}
                                                InputProps={{
                                                    endAdornment:(
                                                        <InputAdornment position="end">
                                                          <IconButton
                                                            aria-label={
                                                                showRePassword ? 'hide the password' : 'display the password'
                                                            }
                                                            onClick={()=>setShowRePassword((show) => !show)}
                                                            onMouseDown={(e)=>e.preventDefault()}
                                                            onMouseUp={(e)=>e.preventDefault()}
                                                            edge="end"
                                                          >
                                                            {showRePassword ? <VisibilityOff /> : <Visibility />}
                                                          </IconButton>
                                                        </InputAdornment>
                                                    )
                                                }}
                                                error={!!errors?.rePassword}
                                                helperText={errors?.rePassword?.message}
                                            />
                                        )}
                                    />
                                </Stack>
                            </Stack>
                            <Stack direction='row' justifyContent="flex-end" gap={2} sx={{ mt: 4 }}>
                                <Button color="inherit" variant="contained" onClick={onCancel} sx={{fontWeight:'bold'}}>キャンセル</Button>
                                <Button variant="contained" type="submit" sx={{fontWeight:'bold'}}>保存</Button>
                            </Stack>
                        </form>
                    </div>                    
                </DialogContent>
            </Dialog>
        </>
    )
}
export default ChangePasswordDialog;